<template>
    <div>
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between align-items-start">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{trans('locale.edit_locale')}}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Update the locale display name and code used throughout language selection.</p>
                    </div>
                </div>
                <router-link to="/configuration/locale" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline">{{trans('general.back')}}</router-link>
            </div>
        </div>

        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="locale"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner">
                    <section class="admin-config-section" :aria-label="trans('locale.edit_locale')">
                        <locale-form :id="id"></locale-form>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import configurationSidebar from '../system-config-sidebar'
    import localeForm from './form';

    export default {
        components : { configurationSidebar, localeForm },
        data() {
            return {
                id:this.$route.params.id
            }
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('multilingual')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }
        }
    }
</script>

<style scoped>
.admin-linear-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
    padding: 1.1rem 1.2rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.06), var(--dash-pro-surface));
}

.admin-linear-head__eyebrow,
.admin-linear-section-label {
    display: block;
    color: var(--lms-primary);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.admin-linear-head__title {
    margin: 0.35rem 0 0;
    color: var(--dash-pro-text);
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: -0.04em;
}

.admin-linear-head__description {
    max-width: 42rem;
    margin: 0.45rem 0 0;
    color: var(--dash-pro-muted);
    font-size: 0.875rem;
    line-height: 1.55;
}

.admin-linear-section-label {
    margin-bottom: 0.35rem;
}

@media (max-width: 575.98px) {
    .admin-linear-head {
        flex-direction: column;
    }
}
</style>
